/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { HubeeStatus } from '@/types';

type HubeeStoreType = {
  hubeeStatus: null | HubeeStatus;
  setHubeeStatus: (status: HubeeStatus | null) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
};

const useHubeeStore = create<HubeeStoreType>()(
  devtools((set) => ({
    hubeeStatus: null,
    setHubeeStatus: (hubeeStatus) => set({ hubeeStatus }),
    loading: false,
    setLoading: (loading) => set({ loading }),
  })),
);

export default useHubeeStore;
